import React, { Component } from "react";

import { connect } from "react-redux";
import * as actions from "./../../actions";

import PropTypes from 'prop-types';

import { withStyles} from '@material-ui/core/styles';

import YouTubeFrame from './../reusableComponents/YouTubeFrame'



import Grid from '@material-ui/core/Grid';

import Paper from '@material-ui/core/Paper'

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';



const styles = theme => ({
  root:{
    paddingTop: 60,
    paddingBottom: theme.spacing.unit * 2,
    position: "relative",
    minHeight: "100vh",
    width: "100%",
    overflow:"hidden",
    background: theme.palette.background.white,
  },


  link:{
    textDecoration:"underline",
    color:"blue",
    cursor: "pointer",
    "&:active":{
      color: "purple",
    },
    "&:visited":{
      color: "purple",
    },
  },
  overlay:{
    position: "absolute",
    top: 160,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundImage: "url('https://i.imgur.com/zXKU0XL.jpg')",
    backgroundSize: "cover",
    opacity: 0.8,

  },

  titleContainer:{
    height: 120,
    width:"100%",

    marginTop: theme.spacing.unit*3,
    marginBottom: theme.spacing.unit*8,

    position: "relative",
    zIndex: 1000,

    textAlign: "center",
    color: theme.palette.common.white
  },
  title:{
    position: "relative",
    paddingTop: 40,
    fontSize: 50,
    fontWeight: "bold",
    fontStyle: "italic",
    textTransform: "uppercase",
    textAlign: "center",
  },

  helmetUp:{
    background: theme.palette.background.dark,
    position: "absolute",
    top: 1,
    left: 0,
    width: "100%",
    height:"50%",
    clipPath:"polygon(0 100%, 100% 100%, 100% 20%,  90% 25%, 80% 19%, 70% 16%, 60% 21%, 50% 23%, 40% 19%, 30% 25%, 20% 21%, 10% 27%,0% 30%)",
    "-webkit-clipPath":"polygon(0 100%, 100% 100%, 100% 20%,  90% 25%, 80% 19%, 70% 16%, 60% 21%, 50% 23%, 40% 19%, 30% 25%, 20% 21%, 10% 15%,0% 30%)",
  },
  helmetDown:{
    background: theme.palette.background.dark,
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "100%",
    height:"50%",
    clipPath:"polygon(0 0%, 100% 0%, 100% 90%,  90% 85%, 80% 93%, 70% 90%, 60% 100%, 50% 90%, 40% 100%, 30% 98%, 20% 90%, 10% 85%, 0% 90%)",
    "-webkit-clipPath":"polygon(0 0%, 100% 0%, 100% 90%,  90% 85%, 80% 93%, 70% 90%, 60% 100%, 50% 90%, 40% 100%, 30% 98%, 20% 90%, 10% 85%, 0% 90%)",
  },

  paper:{
    position: "relative",
    background: "none",
    marginBottom: theme.spacing.unit * 6,

    boxShadow: "none"
  },
  headingContainer:{
    background: theme.palette.background.dark,
    borderBottom: "1px solid white"
  },
  headingContainerExpanded:{
    background: theme.palette.background.dark,

    clipPath:"polygon(0 0%, 100% 0%, 100% 90%,  90% 85%, 80% 95%, 70% 90%, 60% 100%, 50% 90%, 40% 100%, 30% 98%, 20% 95%, 10% 80%, 0% 90%)",
    "-webkit-clipPath":"polygon(0 0%, 100% 0%, 100% 90%,  90% 85%, 80% 95%, 70% 90%, 60% 100%, 50% 90%, 40% 100%, 30% 98%, 20% 95%, 10% 90%, 0% 95%)",
  },
  heading: {
    textTransform: "uppercase",
    fontWeight: "bold",
    color: theme.palette.common.white,
    fontSize: theme.typography.pxToRem(20),
  },

   ytVideoContainer:{
     position: "relative",
     height: 250,
     minHeight: 250,
     width:"100%",

     paddingTop: 0,

   },
   textContainer:{
     display: "flex",
     flexDirection:"row",
     flexWrap: "wrap",

     paddingTop: 0,
   },
   text:{
     textAlign:"justify",
     fontSize: 14,
     paddingBottom: theme.spacing.unit * 1,
     paddingTop: 0,
   }
})


class BetAdvice extends Component{

  state = {
    expanded: "panel1",
    textActive: 0,
  }

  componentDidMount(){
      //this.props.fetchBetAdvicesOnce()
  }

  componentDidUpdate(prevProps){
    //if(!_.isEqual(prevProps.navigationData, this.props.navigationData))}


  }

  showMoreText = (index)=>{
    this.setState({textActive: index})
  }

  handleChange = panel => (event, expanded) => {

   this.setState({
     expanded: expanded ? panel : "",
   });
 };

  static contextTypes = {
    router: PropTypes.object
  }

  render(){
    const {classes, betAdvicesData} = this.props
    const { expanded } = this.state
    if(betAdvicesData !== "loading"){

    }

    return(
      <div   className={classes.root} >
        {
          !this.props.withoutTitle && (
            <div className={classes.titleContainer} >
              <div className={classes.helmetUp}></div>
              <div className={classes.helmetDown}></div>
              <Typography variant="title" color="inherit" className={classes.title} >STAVNE OSNOVE</Typography>
            </div>
          )
        }

        <div style={this.props.withoutTitle ? {top:0}:{}} className={classes.overlay}></div>

        <Grid container justify="center" spacing={16}>

            <Grid item xs={11} sm={10} md={5} lg={3}>
              <Grid container spacing={16} >
                <Grid item xs={12}   className={classes.ytVideoContainer}>
                  <YouTubeFrame video="yLCHEc7xaYA" imgUrl="https://i.imgur.com/exBDp11.jpg" rel="0" modest="1" />
                </Grid>
                <Grid item xs={12}   className={classes.ytVideoContainer}>
                  <YouTubeFrame video="t40kzJkmFfo" imgUrl="https://i.imgur.com/1KWaW2j.jpg" rel="0" modest="1" />
                </Grid>
                <Grid item xs={12}   className={classes.ytVideoContainer}>
                    <YouTubeFrame video="Cf21lV3Xv_c" imgUrl="https://i.imgur.com/E08jzqx.jpg"  rel="0" modest="1" />
                </Grid>
                <Grid item xs={12}   className={classes.ytVideoContainer}>
                    <YouTubeFrame video="u4D3Ey4y9D8" imgUrl="https://i.imgur.com/ethvyuz.jpg" rel="0" modest="1" />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={11} sm={10} md={6} lg={7} style={{position:"relative"}}>

              <Paper className={classes.paper} style={{}}>

                <ExpansionPanel expanded={expanded === 'panel1'} onChange={this.handleChange('panel1')} >

                    <ExpansionPanelSummary className={expanded === 'panel1' ? classes.headingContainerExpanded : classes.headingContainer}  expandIcon={<ExpandMoreIcon style={{color:"white", fontSize: 40}} />}>

                      <div className={classes.column}>
                        <Typography className={classes.heading}>KAJ JE V ŠPORTNIH STAVAH KLJUČNO ZA USTVARJANJE PROFITA?</Typography>
                      </div>
                      <div className={classes.column}>
                        <Typography className={classes.secondaryHeading}></Typography>
                      </div>

                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div >

                        <div className={classes.textContainer}>
                          <Grid container spacing={24}>
                            <Grid item md={12} lg={12}>
                              <Typography className={classes.text} variant="body1">
                                Glede na to, da si pristal na tej spletni strani, te odgovor na to vprašanje verjetno zelo zanima.
                                Odgovor bi lahko politično zavil v celofan ter diplomatsko odgovoril... težko.
                              </Typography>
                              <Typography className={classes.text} variant="body1">

                                A jaz sem tukaj zato, da ti skušam pomagati in pošteno je, da ti konkretno odgovorim na to bistveno vprašanje.
                                Da ti ne bo potrebno brati celotnega besedila je najbolje, da ti kar takoj odgovorim.

                              </Typography>
                              <Typography className={classes.text} variant="title">
                                  Ključna stvar, ki te v športnih stavah pelje do denarja je VALUE! In še enkrat, VALUE!
                              </Typography>

                              <div style={{borderBottom:"1px solid lightgray", margin: this.props.theme.spacing.unit * 1}}></div>
                              <Typography className={classes.text} variant="body1">
                                Ker pa oba veva, da te ta magična beseda sama ne bo pripeljala do denarja, ti predlagam, da se udobno namestiš in do konca prebereš STAVNE OSNOVE.
                                Vsebina, ki sem jo spisal, ni POPOLNOMA BREZPLAČNA. Zaračunal ti bom 23 minut a za marsikoga je lahko teh 23 minut rehabilitacija tvojih stavnih podvigov.
                                <br/>
                                <br/>
                                Poglej videe/preberi spodnje članke katere sem spisal zato, da boš lahko diplomatski odgovor TEŽKO prečrtal ter zamenjal z besedo LAHKO!
                                <br/>
                                <br/>
                                Ne morem ti garantirati uspeha, lahko pa ti pokažem eno od poti, katera dokazano (glej statistiko) pelje do uspeha.
                                Nikakor ne pravim da je to edina pot, a edina, za katero ti lahko iz prve roke povem, da deluje.

                              </Typography>

                            </Grid>

                          </Grid>

                        </div>

                      </div>
                    </ExpansionPanelDetails>

                </ExpansionPanel>


                  <ExpansionPanel expanded={expanded === 'panel2'} onChange={this.handleChange('panel2')}>
                    <ExpansionPanelSummary className={expanded === 'panel2' ? classes.headingContainerExpanded : classes.headingContainer} expandIcon={<ExpandMoreIcon style={{color:"white", fontSize: 40}} />}>
                      <div className={classes.column}>
                        <Typography className={classes.heading}>KAJ JE TO VALUE?</Typography>
                      </div>
                      <div className={classes.column}>
                        <Typography className={classes.secondaryHeading}></Typography>
                      </div>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>

                        <div className={classes.textContainer}>
                          <Grid container spacing={24}>
                            <Grid item md={12} >

                              <Typography className={classes.text} variant="body1">
                                Vrniva se na bistvo... v dobesednem prevodu VALUE pomeni VREDNOST.
                                A katera vrednost? Kakšna vrednost? Čigava vrednost? Vrednost kvot. Ponujenih kvot!
                              </Typography>

                              <Typography className={classes.text} variant="body1">
                                Stavnice oz. sistemi, kateri stojijo za stavnicami, na podlagi algoritmov in vsega kar sodi zraven določajo kvote (o tem kako in kaj, kdaj drugič).
                                <br/>

                                Kvote so številke, katere odražajo procente verjetnosti, da se bo nek dogodek zgodil. To je lahko zmaga, število točk/golov/kartonov oz. karkoli drugega.
                              </Typography>

                              <div style={{borderBottom:"1px solid lightgray", margin: this.props.theme.spacing.unit * 1}}></div>
                              <Typography className={classes.text} variant="title">KAKO PRERAČUNATI KVOTO V PROCENTE ?</Typography>
                              <Typography className={classes.text} variant="body1">

                                 PRIMER (Igralec ima kvoto: 1.9)
                                 <br />
                                 1 : kvota x 100 = PROCENTI => 1 : 1.9 x 100 = 52,63%
                                 <br/>
                                 *Igralec bi moral imeti v teoriji 52,63% možnosti za zmago.
                              </Typography>

                              <Typography className={classes.text} variant="body1">
                                Vendar pa kvota, ki jo postavi stavnica, ne pomeni da je nujno realna.
                                Dogaja se, in to zelo pogosto, da stavnica ne oceni situacije dovolj natančno.
                                <br/>
                                To pomeni, da lahko ti oz. tvoj stavni svetovalec na podlagi znanja (s tem ne mislim zgolj športnega znanja) določiš kvote natančneje.
                                Boljši stavničarji kot smo, natančneje lahko določimo realnost situacije.
                              </Typography>
                              <Typography className={classes.text} variant="body1">
                                Ko opazimo, da stavnica ponuja večjo vrednost od realne, moramo to izkoristiti.
                                <br/>
                                Kako izkoristimo? Tako, da stavimo na to stavo, jih udarimo po lepinji in oropamo bankomate!
                                <br/>
                                <br/>

                              </Typography>
                            </Grid>


                          </Grid>

                        </div>

                    </ExpansionPanelDetails>
                  </ExpansionPanel>

                <ExpansionPanel expanded={expanded === 'panel3'} onChange={this.handleChange('panel3')}>
                  <ExpansionPanelSummary className={expanded === 'panel3' ? classes.headingContainerExpanded : classes.headingContainer} expandIcon={<ExpandMoreIcon style={{color:"white", fontSize: 40}} />}>
                    <div className={classes.column}>
                      <Typography className={classes.heading}>KAKO IZRAČUNAMO VALUE (EV)?</Typography>
                    </div>
                    <div className={classes.column}>
                      <Typography className={classes.secondaryHeading}></Typography>
                    </div>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>

                      <div className={classes.textContainer}>
                        <Grid container spacing={24}>
                          <Grid item md={12} >

                            <Typography className={classes.text} variant="body1">
                              (MOŽNI PROFIT x TVOJA OCENA ZMAGE V %) – (VLOŽEK x TVOJA OCENA PORAZA V %) = VALUE(EV) / VLOŽEK
                              <br/>
                              PRIMER
                              <br/>
                              Stavnica postavi kvoto 2,4 na neko košarkarsko moštvo.
                              Ta ekipa naj bi imela manj možnosti za zmago od nasprotnika.

                              Naša argumentirana/objektivna ocena je, da ima ta ista ekipa nekoliko več kot 50% možnosti za zmago, recimo 53%.
                              To predstavlja kvoto 1,9. Razlika med 2,4 (možnosti za zmago: 42%) in 1,9 (možnosti za zmago 53%) predstavlja value.
                              Razlika v možnosti za zmago je 11%, value pa znaša 26,31%
                              <br/>
                              <br/>
                              PRIMER
                              <br/>
                              Vplačilo 100€ na kvoto 2,4 (kvota stavnice), mi pa ocenjujemo, da je realna kvota na to ekipo 1,9.
                              <br/>
                              <br/>
                              140€ x 52,63 – 100€ x 47,37 = 2631 / 100 = 26,31%
                            </Typography>
                            <div style={{borderBottom:"1px solid lightgray", margin: this.props.theme.spacing.unit * 1}}></div>
                            <Typography className={classes.text} variant="body1">
                              Kaj se bo na dvoboju zgodilo ni pomembno. Na dolgi rok šteje (in se bo tudi poznalo na tvojem računu) samo to, da si ti izplačan več kot je realno.

                              <br/>

                              TO JE VALUE!
                            </Typography>

                          </Grid>


                        </Grid>

                      </div>

                  </ExpansionPanelDetails>
                </ExpansionPanel>
                <ExpansionPanel expanded={expanded === 'panel4'} onChange={this.handleChange('panel4')}>
                  <ExpansionPanelSummary className={expanded === 'panel4' ? classes.headingContainerExpanded : classes.headingContainer} expandIcon={<ExpandMoreIcon style={{color:"white", fontSize: 40}} />}>
                    <div className={classes.column}>
                      <Typography className={classes.heading}>KAKO NAJDEŠ VALUE?</Typography>
                    </div>
                    <div className={classes.column}>
                      <Typography className={classes.secondaryHeading}></Typography>
                    </div>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>

                      <div className={classes.textContainer}>
                        <Grid container spacing={24}>
                          <Grid item md={12} >
                            <Typography className={classes.text} variant="body1">
                             Vem, da te sedaj že zanima, kako boš našel ta j***** value?
                             To pa je že tisto težje vprašanje. Če te zanima kje sem danes jaz našel value lahko zadevo izveš tako, da naročiš katerega od paketov.
                            </Typography>
                            <Typography className={classes.text} variant="body1">
                             Ja, tudi ODLOČITEV, da kupiš paket JE ZELO LEP VALUE!
                             <br/>
                             Preden zaključiva prvo poglavje naj razčistiva še en mit. Nekaj, kar večina misli pa seveda popolnoma ne drži.
                             So value res lahko samo visoke kvote? Absolutno ne!
                            </Typography>
                            <Typography className={classes.text} variant="body1">
                              Value je lahko tudi kvota 1,3 ali celo 1,2, a moraš v tem primeru poiskati ekipo/igralca,
                              kateri ima za zmago recimo 90% možnosti. Vemo pa,
                              da v današnjem športu težko naletimo na takšno ekipo/igralca,
                              ki bi bil tako zelo dominanten in bi ga hkrati stavnica narobe ocenila.
                              Iz tega razloga je bistveno lažje poiskati value v višjih kvotah, kjer so odstopanja večja.
                             <br/>
                              Skratka, če boš delal prave odločitve in igral na value, bo rezultat na dolgi rok prišel sam do sebe,
                              ti pa boš s športnimi stavami ustvarjal denar.

                            </Typography>
                          </Grid>
                        </Grid>

                      </div>

                  </ExpansionPanelDetails>
                </ExpansionPanel>
                <ExpansionPanel expanded={expanded === 'panel5'} onChange={this.handleChange('panel5')}>
                  <ExpansionPanelSummary className={expanded === 'panel5' ? classes.headingContainerExpanded : classes.headingContainer} expandIcon={<ExpandMoreIcon style={{color:"white", fontSize: 40}} />}>
                    <div className={classes.column}>
                      <Typography className={classes.heading}>MANJKA DISCIPLINE? KAKO IGRATI ŠPORTNE STAVE DISCIPLINIRANO?  </Typography>
                    </div>
                    <div className={classes.column}>
                      <Typography className={classes.secondaryHeading}></Typography>
                    </div>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>

                      <div className={classes.textContainer}>
                        <Grid container spacing={24}>
                          <Grid item md={12} >
                            <Typography className={classes.text} variant="body1">
                              Ok, sedaj veva kaj je to dobra stava.
                              A ne glede na to, kako dobre stave imaš, ne glede na to, koliko stav zadaneš.... če ni discipline, ni kruha.
                              Če je value »fotr«, je disciplina mama.
                            </Typography>
                            <Typography className={classes.text} variant="body1">
                              Noben stavni svetovalec na svetu ti discipline ne more vsiliti. Vem, da je težko a enostavno moraš to razčistiti sam pri sebi. Brez discipline lahko nek kratek čas premaguješ igro, na dolgi rok pa ni pogojev.
                              Iz tega razloga je bankroll managment toliko pomembnejši, saj ti pomaga igrati bolj disciplinirano.
                              <br/>
                              Bankroll management je osnova športnih stav.
                            </Typography>
                          </Grid>
                        </Grid>

                      </div>

                  </ExpansionPanelDetails>
                </ExpansionPanel>
                <ExpansionPanel expanded={expanded === 'panel6'} onChange={this.handleChange('panel6')}>
                  <ExpansionPanelSummary className={expanded === 'panel6' ? classes.headingContainerExpanded : classes.headingContainer} expandIcon={<ExpandMoreIcon style={{color:"white", fontSize: 40}} />}>
                    <div className={classes.column}>
                      <Typography className={classes.heading}>KAJ POMENI BANKROLL MANAGEMENT?</Typography>
                    </div>
                    <div className={classes.column}>
                      <Typography className={classes.secondaryHeading}></Typography>
                    </div>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>

                      <div className={classes.textContainer}>
                        <Grid container spacing={24}>
                          <Grid item md={12} >
                            <Typography className={classes.text} variant="body1">
                              Bankroll je denar, ki ga imaš namenjenega za športne stave. Management pa je upravljanje le tega.
                            </Typography>
                            <Typography className={classes.text} variant="body1">

                              Mislim, da ni potrebno posebej izpostavljati,  pa vendarle... ŠPORTNE STAVE IGRAJ ODGOVORNO!
                              <br/>
                              <br/>
                              Nikakor ne smeš za bankroll določiti vsega denarja, ki ga imaš.
                              Če imaš na razpolago 300€, ti na kraj pameti ne sme pasti, da bi vplačal 300€ na 1 stavo.

                              Ne pozabi! Igraš igro na srečo v kateri je možen tudi bankrot.
                              <br/>

                              In v kolikor pride do bankrota, to ne pomeni konec sveta, ker imaš za sabo še vedno denar.
                              Na tej točki pa se seveda vprašaš ali nadaljuješ z igranjem in dokapitaliziraš bankroll ali pač to ni zate.
                            </Typography>

                            <Typography className={classes.text} variant="body1">
                              Kot sem že omenil je enostavno nemogoče vedeti, kdaj boš stavo zadel in kdaj ne.
                              Zato se s tem nima smisla obremenjevati. Noben stavničar ni imun na downswinge (obdobja porazov).
                              Enostavno vsak kdaj zapade v obdobje, ko si sledi poraz za porazom. Kdor to zanika, laže.
                              <br/>
                              Zato, da takšna obdobja preživiš pa je ključen dober bankroll managment.
                              Bankroll management je torej nek sistem igranja, kateri ti pomaga preživeti poraze.
                              <br/>
                              Mimogrede, v takšnih obdobjih je pomembno samo to, da se vprašaš ali veš kaj delaš in ali verjameš v to.
                              Če je odgovor pritrdilen, samo še bolj grizeš in slej ko prej se bo zadeva obrnila, seveda če res delaš kvalitetno.
                              Ne škodi tudi analizirati porazov in hkrati gristi še naprej ter iskati nove dobre stave.
                              Porazi so zgolj sestavni del te igre in tega bi se moral vsak zavedati.
                            </Typography>
                          </Grid>


                        </Grid>

                      </div>

                  </ExpansionPanelDetails>
                </ExpansionPanel>
                <ExpansionPanel expanded={expanded === 'panel7'} onChange={this.handleChange('panel7')}>
                  <ExpansionPanelSummary className={expanded === 'panel7' ? classes.headingContainerExpanded : classes.headingContainer} expandIcon={<ExpandMoreIcon style={{color:"white", fontSize: 40}} />}>
                    <div className={classes.column}>
                      <Typography className={classes.heading}>KOLIKO NAJ ZNAŠA 1 ENOTA?</Typography>
                    </div>
                    <div className={classes.column}>
                      <Typography className={classes.secondaryHeading}></Typography>
                    </div>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>

                      <div className={classes.textContainer}>
                        <Grid container spacing={24}>
                          <Grid item md={12} >
                            <Typography className={classes.text} variant="body1">
                              Skratka, bankroll management definiraš na podlagi svojih stavnih sposobnosti oz. večletne analize svoje statistike.
                              Bankroll management je tako stvar posameznika.
                              <br/>
                              Jaz sem na podlagi moje večletne statistike ugotovil, da zelo redko oz. v zadnjih letih praktično nikoli ne zaniham za več kot 200 enot.
                              Na podlagi tega določim višino 1 enote in igram potrpežljivo.
                              <br/>
                              Zelo pomembno je, da se omeji višino maksimalne stave (max bet – 10/10). V mojem primeru, ko govorim o varnem igranju, maximalna stava predstavlja 5% bankrolla.
                              Če te zanima več o enotah si poglej naslednji članek.
                            </Typography>
                            <Typography className={classes.title}>KOLIKO NAJ ZNAŠA 1 ENOTA? </Typography>
                            <Typography className={classes.text} variant="body1">
                              Dobro vprašanje. Jaz svetujem, da se moje nasvete igra po dveh principih med katerima se posameznik sam pri sebi odloči za eno.
                            </Typography>
                            <Typography className={classes.text} variant="body1">
                              1. VARNO IGRANJE (1 enota = 0,5%)
                              <br/>
                              2. TVEGANO IGRANJE (1 enota = 1%)
                              <br/>
                              Logično je, da bo donos drugačen a jasno mora biti tudi to, da bodo variacije na katere moramo biti pripravljeni pri tveganem igranju večje.
                            </Typography>
                            <div style={{borderBottom:"1px solid lightgray", margin: this.props.theme.spacing.unit * 1}}></div>

                            <Typography className={classes.text} variant="body1">
                              1 enota je torej tako kot valuta. Nikakor ne govorimo o tem, da je 1 enota neko dejstvo.
                              Določi si jo vsak sam. Slišal sem recimo že očitke: » Ti na dan igraš preveč stav.«
                              <br/>
                              To sploh ni pomembno, ker če so nekomu dnevni vložki previsoki, si lahko sam zmanjša enoto in odigra svojemu bankrollu primerno.
                              Tako enostavno je to. Zagotovo pa je bolje odigrati več stav, kot manj saj boš s tem hitreje dosegel dolgi rok.
                              To ne pomeni, da moraš hiteti, še manj igrati slabe stave. Je pa prav, da se odigra vsako stavo v kateri je value.

                            </Typography>
                          </Grid>
                        </Grid>
                      </div>

                  </ExpansionPanelDetails>
                </ExpansionPanel>
                <ExpansionPanel expanded={expanded === 'panel8'} onChange={this.handleChange('panel8')}>
                  <ExpansionPanelSummary className={expanded === 'panel8' ? classes.headingContainerExpanded : classes.headingContainer} expandIcon={<ExpandMoreIcon style={{color:"white", fontSize: 40}} />}>
                    <div className={classes.column}>
                      <Typography className={classes.heading}>KOLIKO € NAJ ZNAŠA MOJ BANKROLL? </Typography>
                    </div>
                    <div className={classes.column}>
                      <Typography className={classes.secondaryHeading}></Typography>
                    </div>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>

                      <div className={classes.textContainer}>
                        <Grid container spacing={24}>
                          <Grid item md={12} >
                            <Typography className={classes.text} variant="body1">
                              To je zelo pogosto vprašanje, ki ga dobim. Jaz neki xy osebi ne morem reči: »Ti igraj za xxx €«,
                              ker ne poznam njegove finančne situacije in zmožnosti.
                              Bankroll si mora določiti vsak sam.
                              <br/>
                              Jasno pa mora biti, da bo zaslužek odvisen od vložka. Tako kot pri vsaki investiciji.
                              Nekdo, ki začne z 200€, bo imel enako enot profita kot nekdo, ki začne s 1000€.
                              Vsota na accountu pa bo seveda drugačna.
                              <br/>
                              Tako, če se boš držal bankroll managmenta in igral value stave, sploh ni pomembno kdo bo zmagal katero tekmo.
                              Sedaj ključno stvar stav poznaš, osnovo stav prav tako. Čas je, da začneš služiti!
                              Še prej pa bi te rad opozoril na najpogostejšo napako zaradi katere največ stavničarjev izgublja denar.

                            </Typography>
                          </Grid>

                        </Grid>

                      </div>

                  </ExpansionPanelDetails>
                </ExpansionPanel>
                <ExpansionPanel expanded={expanded === 'panel9'} onChange={this.handleChange('panel9')}>
                  <ExpansionPanelSummary className={expanded === 'panel9' ? classes.headingContainerExpanded : classes.headingContainer} expandIcon={<ExpandMoreIcon style={{color:"white", fontSize: 40}} />}>
                    <div className={classes.column}>
                      <Typography className={classes.heading}>NAJPOGOSTEJŠA NAPAKA ZARADI KATERE IZGUBLJAŠ DENAR! </Typography>
                    </div>
                    <div className={classes.column}>
                      <Typography className={classes.secondaryHeading}></Typography>
                    </div>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>

                      <div className={classes.textContainer}>
                        <Grid container spacing={24}>
                          <Grid item md={12} >
                            <Typography className={classes.text} variant="body1">
                              Glede na to, da se s stavnimi nasveti ukvarjam že od leta 2009
                              (poleg spletne strani www.betmoneymaker.com sem takrat ustvaril tudi prvo slovensko stavno skupino na Facebooku)
                              sem v tem poslu doživel in videl že marsikaj.
                              Dejstvo je, da več kot 95% stavničarjev s stavami denar izgublja. Ker vem kje počnejo glavna napako, si zares želim, da ti te napake ne bi počel.
                            </Typography>
                            <Typography className={classes.text} variant="title">NAJPOGOSTEJŠA NAPAKA JE IGRANJE PREVEČ NAPOVEDI NA 1 KOMBINACIJO/STAVO.</Typography>
                            <Typography className={classes.text} variant="body1">
                              Kolikokrat se ti je že zgodilo, da si na stavnem listku zgrešil samo 1 napoved?
                              Kolikokrat si pomislil, da ti pa res nimaš sreče?
                              Pogosto se zgodi, da zgrešiš celo zadnji par, katerega čakaš za dobitek.

                            </Typography>
                            <Typography className={classes.text} variant="title">Veš v čemu je problem? Problem je v temu, da odigraš 1 par preveč.</Typography>
                            <Typography className={classes.text} variant="body1">
                              Zdaj pa se odloči, ali boš življenje posvetil temu, da boš ugotavljal kateri par te bo zaj**** (zelo verjetno ti to do uspeha ne bo pomagalo) ali pa boš spremenil način igranja in začel služiti.
                              <br/>
                              Predlagam drugo opcijo.
                              Enostavno ni možno ugotoviti, kateri bo tisti par, ki ne bo šel čez. In kot sem v prejšnjem članku že napisal,
                              ni pomembno kakšen bo rezultat na tekmi, pomembne so pravilne odločitve.
                              Dogaja se, da vzameš dobro stavo a enostavno ne gre čez. Dobra stava namreč ne pomeni dobljena stava ampak stava z value-om,
                              kjer se dogaja to kar predvidevaš pred dvobojem, to pa še ne pomeni tudi pravilnega končnega rezultata.
                            </Typography>
                          </Grid>


                        </Grid>

                      </div>

                  </ExpansionPanelDetails>
                </ExpansionPanel>
                <ExpansionPanel expanded={expanded === 'panel10'} onChange={this.handleChange('panel10')}>
                  <ExpansionPanelSummary className={expanded === 'panel10' ? classes.headingContainerExpanded : classes.headingContainer} expandIcon={<ExpandMoreIcon style={{color:"white", fontSize: 40}} />}>
                    <div className={classes.column}>
                      <Typography className={classes.heading}>ZAKAJ NI PAMETNO IGRATI KOMBINACIJ? </Typography>
                    </div>
                    <div className={classes.column}>
                      <Typography className={classes.secondaryHeading}></Typography>
                    </div>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>

                      <div className={classes.textContainer}>
                        <Grid container spacing={24}>
                          <Grid item md={12} >
                            <Typography className={classes.text} variant="body1">
                              Verjetno bi se bilo bolje vprašati, zakaj bi bilo pametno igrati več parov v eno kombinacijo? Ni pametno.
                              Enostavno so možnosti za uspeh zelo majhne, da bi zadel 6,8,10,15 napovedi naenkrat.
                              Poleg tega je velika škoda, da ti neko super napoved z lepo kvoto pokvari neka slaba stava z nizko kvoto.
                              Škoda je, da ne bi dobil izplačano dobro stavo.
                              <br/>
                              V teoriji se lahko tudi s kombinacijami ustvarja profit na dolgi rok, a ker gre za visoke skupne kvote in velike variacije je ta dolgi rok lahko predolg,
                              da ga doživiš. Poleg tega pa je zares težko poiskati več super stav z value-om in ne narediti napake pri nobeni od analiz.
                              Da, ne govorimo o temu, da ne smeš imeti smole niti na 1 srečanju.
                              <br/>
                              Kot neprestano poudarjam je bistvo pri vsaki stavi (tudi pri kombinacijah), da value najdeš v vsaki napovedi. Samo tako se bo tvoja denarnica debelila.
                              <br/>
                              Igranje singlov oz. eventuelno doubleov pa je boljše od kombinacij tudi zato, ker se porazi in zmage med seboj »pokrajšajo«.
                            </Typography>
                            <div style={{borderBottom:"1px solid lightgray", margin: this.props.theme.spacing.unit * 1}}></div>

                            <Typography className={classes.text} variant="body1">
                              PRIMER
                              <br/>
                               Odigraš 10 napovedi, zadaneš jih 7.
                            </Typography>
                            <Typography className={classes.text} variant="body1">
                              1. Vplačaš jih kot 2 kombinaciji po 5 parov.
                              <br/>
                              Na prvi stavi zadaneš 4 od 5 stav, na drugi pa 3 od 5 stav. Torej obe stavi zgrešiš in narediš minus.
                              <br/>

                              2. Vplačaš jih kot 10 singlov.
                              <br/>
                              Zmage in porazi se med seboj seštevajo ter odštevajo in si tako na koncu v profitu, v najslabšem primeru okrog 0.
                            </Typography>
                          </Grid>


                        </Grid>

                      </div>

                  </ExpansionPanelDetails>
                </ExpansionPanel>
                <ExpansionPanel expanded={expanded === 'panel11'} onChange={this.handleChange('panel11')}>
                  <ExpansionPanelSummary className={expanded === 'panel11' ? classes.headingContainerExpanded : classes.headingContainer} expandIcon={<ExpandMoreIcon style={{color:"white", fontSize: 40}} />}>
                    <div className={classes.column}>
                      <Typography className={classes.heading}>ZAKAJ POTEM STAVNIČARJI SPLOH IGRAJO KOMBINACIJE? </Typography>
                    </div>
                    <div className={classes.column}>
                      <Typography className={classes.secondaryHeading}></Typography>
                    </div>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <div >

                      <div className={classes.textContainer}>
                        <Grid container spacing={24}>
                          <Grid item md={12} >
                            <Typography className={classes.text} variant="body1">
                              Logično, zato ker bi radi na hitro zaslužili veliko. Vendar pa vemo, da se na hitro zaslužiti veliko ne da. Vsaj ne legalno.
                              Zagotovo je bolje služiti počasi in varno, kot hitro narediti velik minus.
                            </Typography>
                            <Typography className={classes.text} variant="title">ZATO IGRAJ SINGLE (1 par na stavo) OZ. NAJVEČ DOUBLE (2 para na stavo).</Typography>
                            <Typography className={classes.text} variant="body1">
                              Sedaj sva ugotovila, da nisi rojen pod nesrečno zvezdo.
                              Nič več smole nimaš kot kdo drug, vprašanje je samo po kakšnem sistemu igraš... pametno (singli in doubli) ali nespametnem (kombinacije).
                              Sreča se na dolgi rok praktično izniči, z igranjem singlov in double-ov pa boš hitreje prišel do dolgega roka in pokazala se bo kvaliteta.
                              <br/>
                              <br/>
                              Če sem enemu dal misliti in se bo držal mojega nasveta sem naredil veliko.
                            </Typography>
                          </Grid>
                        </Grid>

                      </div>

                    </div>
                  </ExpansionPanelDetails>
                </ExpansionPanel>


                <ExpansionPanel expanded={expanded === 'panel12'} onChange={this.handleChange('panel12')}>
                  <ExpansionPanelSummary className={expanded === 'panel12' ? classes.headingContainerExpanded : classes.headingContainer} expandIcon={<ExpandMoreIcon style={{color:"white", fontSize: 40}} />}>
                    <div className={classes.column}>
                      <Typography className={classes.heading}>NAJBOLJŠI NASVET, KI TI GA LAHKO DAM ZA IGRANJE ŠPORTNIH STAV.</Typography>
                    </div>
                    <div className={classes.column}>
                      <Typography className={classes.secondaryHeading}></Typography>
                    </div>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <div >

                      <div className={classes.textContainer}>
                        <Grid container spacing={24}>
                          <Grid item md={12} >
                            <Typography className={classes.text} variant="subheading">KAR SEJEŠ, POL TUD ŽANJEŠ...</Typography>
                            <Typography className={classes.text} variant="body1">
                              in dejansko je tako! Tvoj uspeh v športnih stavah bo odvisen od vloženega truda.
                              <br/>
                              Vem, da marsikdo napovedi določa tako, da odpre stavno listo in pač poklika, kar mu je všeč.
                              Veliko je takšnih, kateri pogledajo statistiko in vidijo, da neka ekipa premaguje vsepovprek in zato stavi na njih.
                              Drugi pogledajo medsebojna srečanja in stavijo na podlagi tega. Spet tretji vidijo, da ekipa dosega veliko zadetkov in igrajo over golov... NE!To ni dovolj.
                              Na podlagi takšnih razlogov ne morete dobiti prednosti pred stavnico. Tako se ne najde value-a, saj takšne zadeve stavnice ukalkulirajo v kvote.
                            </Typography>
                            <Typography className={classes.text} variant="body1">
                              Športne stave niso poznavanje športa. Športne stave so številke!
                              Igra na srečo v kateri lahko s pravim pristopom zmanjšaš faktor sreče.
                            </Typography>
                            <Typography className={classes.text} variant="body1">
                              Ne išči bližnjic, ne išči napak stavnic, ne išči nameščenih tekem.
                              Tako je kot povsod, denar boš na dolgi rok ustvarjal izključno s trdim delom.
                              Poleg športnega znanja in spremljanja športnih dogodkov je ključno gibanje kvot in pravilna interpretacija le tega.
                              Samo spremljanje in znanje absolutno ne bosta dovolj.
                              <br/>
                              Če bi bila, bi bila večina športnikov, športnih novinarjev, trenerjev, skratka delavcev v športu izjemnih stavničarjev, pa temu ni tako.
                            </Typography>
                            <Typography className={classes.text} variant="body1">
                              Ne išči bližnjic, ne išči napak stavnic, ne išči nameščenih tekem.
                              Tako je kot povsod, denar boš na dolgi rok ustvarjal izključno s trdim delom.
                              Poleg športnega znanja in spremljanja športnih dogodkov je ključno gibanje kvot in pravilna interpretacija le tega.
                              Samo spremljanje in znanje absolutno ne bosta dovolj.
                              <br/>
                              Če bi bila, bi bila večina športnikov, športnih novinarjev, trenerjev, skratka delavcev v športu izjemnih stavničarjev, pa temu ni tako.
                            </Typography>
                            <Typography className={classes.text} variant="body1">
                              Sam sem začel ustvarjati profit, ko sem se postavil pred dejstvo, da spremljanje športa ne bo dovolj.
                              Moja hipoteza je, da nobeno športno znanje ni pomembnejše od natančne oz. pravilne analize gibanja kvot.
                              V teoriji bi to pomenilo, da bi lahko stave določal brez spremljanja športa a to povsem ne drži.
                              Z znanjem in spremljanjem si ti lahko natančneje razlagaš gibanje kvot, kar ti omogoča boljše odločitve. Se pa dogajajo tudi situacije,
                              kjer je pomik kvote popolnoma nelogičen a dober stavničar bo tudi takšno situacijo znal prebrati in se pravilno odločiti.
                            </Typography>
                            <Typography className={classes.text} variant="body1">
                              To je to! Sedaj veš vse, kar moraš vedeti, da s športnimi stavami začneš ustvarjati denar. Če imaš dovolj teorije, pojdiva na prakso. Še pred tem pa...
                            </Typography>
                            <Typography className={classes.text} variant="title">
                              NAJBOLJŠI NASVET, KI TI GA LAHKO DAM ZA IGRANJE ŠPORTNIH STAV JE...TAKOJ ZDAJ <span className={classes.link} onClick={()=>this.context.router.history.push("/narocilo")}>NAROČI PAKET!</span>
                            </Typography>

                          </Grid>

                        </Grid>

                      </div>

                    </div>
                  </ExpansionPanelDetails>
                </ExpansionPanel>
              </Paper>
            </Grid>

        </Grid>
      </div>
    )


  }
}

BetAdvice.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = ({ betAdvicesData }) => {
  return {
    betAdvicesData
  };
};

export default connect(mapStateToProps, actions)( withStyles(styles, { withTheme: true })(BetAdvice))


/*
{
  betAdvicesData !== "loading" && Object.values(betAdvicesData).map((betAdvice, i)=>{
    return(
      <ExpansionPanel key={i} defaultExpanded={i==0 ? true : false}>
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
          <div className={classes.column}>
            <Typography className={classes.heading}>{betAdvice.title}</Typography>
          </div>
          <div className={classes.column}>
            <Typography className={classes.secondaryHeading}>{betAdvice.subtitle}</Typography>
          </div>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <div style={{display:"flex", flexDirection: "row", width:"100%"}}>

            <div style={{width:"50%"}}>
              <Typography>
                {betAdvice.description}
              </Typography>
            </div>
            <div className={classes.ytVideoContainer}>
              <YouTube
                videoId={betAdvice.ytVideoId}
                opts={opts}
              />
            </div>
          </div>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    )
  })
}
*/



// WEBPACK FOOTER //
// ./src/components/main/BetAdvices.js